import { render, staticRenderFns } from "./like.vue?vue&type=template&id=20407958&scoped=true"
import script from "./like.vue?vue&type=script&lang=js"
export * from "./like.vue?vue&type=script&lang=js"
import style0 from "./like.vue?vue&type=style&index=0&id=20407958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20407958",
  null
  
)

export default component.exports